export const MESSAGES: New_Messages = {
  CREATE: {
    SUCCESS: (type) => ({
      variant: "default",
      description: `${type} Adicionado com sucesso!`,
      duration: 5000,
      closeOnClick: true,
    }),
    ERROR: (type) => ({
      variant: "destructive",
      description: `Erro ao Adicionar ${type}.`,
      duration: 5000,
      closeOnClick: true,
    }),
  },
};

export const MESSAGES_EXCEPTION: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Exceção criado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar Exceção.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};

interface Message {
  variant: "default" | "destructive";
  description: string;
  duration: number;
  closeOnClick: boolean;
}

type MessageBuilder = (type: "NCM" | "Produto") => Message;

interface MessageType {
  SUCCESS: MessageBuilder;
  ERROR: MessageBuilder;
}

interface New_Messages {
  [key: string]: MessageType;
}
